import { render, staticRenderFns } from "./LoginAnnouncement.vue?vue&type=template&id=00c6a4c8&scoped=true&"
import script from "./LoginAnnouncement.vue?vue&type=script&lang=ts&"
export * from "./LoginAnnouncement.vue?vue&type=script&lang=ts&"
import style0 from "./LoginAnnouncement.vue?vue&type=style&index=0&id=00c6a4c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c6a4c8",
  null
  
)

export default component.exports